<template>
  <section v-if="variants.v1 === variant">
    <div
      class="pxp-video-section pxp-cover tw-pt-24"
      :style="`background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(${vars.backgroundImage})`"
    >
      <div class="container">
        <library-title tag="h2" class="pxp-section-h2 text-center text-white" :text="vars.titleText"> </library-title>
        <library-text
          :html="vars.descriptionHtml"
          class="pxp-text-light text-center text-white tw-mt-4 tw-leading-4"
        ></library-text>
        <div class="pt-100 pb-100 text-center">
          <a class="pxp-video-section-trigger tw-cursor-pointer" @click="togglePopup(true)">
            <span class="fa fa-play"></span>
          </a>
        </div>
      </div>
      <library-popups-video-popup v-model:is-visible="isPopupVisible" :video-url="vars.contentVideo" />
    </div>
  </section>

  <section v-if="variants.v2 === variant">
    <div
      class="pxp-video-section pxp-cover tw-pt-24"
      :style="`
      background-image:
        linear-gradient(rgba(127,51,143,0.4), rgba(127,51,143,0.4)),
        linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)),
        url(${vars.backgroundImage});
      background-size: cover;
      background-position: center;
    `"
    >
      <div class="container">
        <h3 class="tw-text-center" style="color: #fff !important">{{ vars.titleText }}</h3>
        <p class="text-center text-white tw-mt-4">{{ vars.descriptionText }}</p>

        <div class="pt-100 pb-100 text-center">
          <div @click="togglePopup(true)" class="tw-inline-block tw-cursor-pointer">
            <svg width="100" height="100" viewBox="0 0 75 76" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M37.5 0.5C30.0832 0.5 22.833 2.69934 16.6661 6.81989C10.4993 10.9404 5.69282 16.7971 2.85453 23.6494C0.0162482 30.5016 -0.726377 38.0416 0.720569 45.3159C2.16751 52.5902 5.73904 59.272 10.9835 64.5165C16.228 69.761 22.9098 73.3325 30.1841 74.7795C37.4584 76.2264 44.9984 75.4838 51.8506 72.6455C58.7029 69.8072 64.5596 65.0007 68.6801 58.8339C72.8007 52.667 75 45.4168 75 38C75 33.0754 74.0301 28.1991 72.1455 23.6494C70.2609 19.0997 67.4987 14.9657 64.0165 11.4835C60.5343 8.0013 56.4004 5.23907 51.8506 3.35452C47.3009 1.46997 42.4246 0.5 37.5 0.5ZM30 54.875V21.125L52.5 38L30 54.875Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
      </div>

      <library-popups-video-popup v-model:is-visible="isPopupVisible" :video-url="vars.contentVideo" />
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'Theme3FeaturedVideoSection',

  mixins: [ComponentMixin],

  head() {
    return {};
  },

  data() {
    return {
      isPopupVisible: false,
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
    };
  },

  methods: {
    togglePopup(status = false) {
      this.isPopupVisible = status;
    },
  },
});
</script>
